import { Modal, Select } from 'antd'
import * as walletState from '@/hooks/crypto/paymentState'
import { useEffect, useState } from 'react'
import { Networks } from '@/crypto/chain_info'

export const CryptoPaymentModal = ({
  payState,
  walletInfo = {},
  onCancel,
  onNext,
  allowedNetworks,
  allowedTokens,
  width,
  setBooking = () => {},
}) => {
  const optimismIsOption =
    allowedNetworks.findIndex((n) => {
      return n === 10
    }) >= 0

  const defaultNetwork = optimismIsOption
    ? 10
    : allowedNetworks.length > 0
    ? allowedNetworks?.[0]
    : 0

  const [network, setNetwork] = useState(0)
  const { wallet, chainId } = walletInfo

  useEffect(() => {
    setNetwork(defaultNetwork)
  }, [])

  const [token, setToken] = useState(-1)

  const clearLocal = () => {
    setNetwork(0)
    setToken(-1)
  }

  //only show this modal while the user is going through payment steps
  const visible = payState && payState !== walletState.CONNECTING

  useEffect(() => {
    if (!visible) {
      clearLocal()
    }
  }, [visible])

  const onNetworkSelect = (net) => {
    setNetwork(net)
  }


  let comp = null
  switch (payState) {
    case walletState.SELECTING_NET: {
      comp = (
        <PickNetwork
          options={allowedNetworks}
          onSelect={onNetworkSelect}
          value={network}
        />
      )
      break
    }
    case walletState.SELECTING_TOKEN: {
      comp = <PickToken options={allowedTokens} onSelect={(t) => setToken(t)} />
      break
    }

    case walletState.INSUFFICIENT_BALANCE: {
      comp = <InsufficientBalance />
      break
    }

    case walletState.SPEND_INSUFFICIENT: {
      comp = <SpendIncrease />
      break
    }
    case walletState.SPEND_SUFFICIENT: {
      comp = <SignPayment />
      break
    }
    case walletState.SIGNED: {
      comp = <Finished />
      break
    }
  }

  return (
    <Modal
      className="common-modal"
      open={visible}
      title="Pay with Crypto"
      onCancel={() => {
        clearLocal()
        onCancel()
      }}
      onOk={() => {
        onNext({
          chainId: network,
          token: token,
        })
      }}
      destroyOnClose={true}
      width={width || 600}
      cancelButtonProps={{ size: 'large' }}
      okButtonProps={{
        size: 'large',
        style: { display: comp ? 'inline' : 'none' },
      }}
    >
      <WalletAndChain wallet={wallet} chainId={chainId} />
      {comp ? comp : <p>{`${payState}...` || 'Connecting...'}</p>}
    </Modal>
  )
}

const PickNetwork = ({ options, onSelect, defaultNetwork }) => {
  const opts = options.map((o) => ({
    value: o,
    label: Networks[o].name,
  }))

  opts.unshift({
    value: 0,
    label: 'Select a network',
  })

  return (
    <>
      <span>
        Please select from the list of allowed networks to pay for this event.
      </span>
      <div>
        <Select
          style={{
            minWidth: 170,
            textAlign: 'left',
          }}
          onChange={onSelect}
          options={opts}
          defaultValue={0}
        />
      </div>
    </>
  )
}

const PickToken = ({ options, onSelect }) => {
  if (options.length === 0) {
    return <></>
  }

  const opts = options.map((o, i) => ({
    value: i,
    label: o.symbol,
  }))
  return (
    <>
      <span>
        Please select from the list of allowed tokens available on the network
        you selected
      </span>
      <div>
        <Select
          style={{
            minWidth: 170,
            textAlign: 'left',
          }}
          defaultValue={opts.length > 0 ? opts[0].value : undefined}
          onChange={onSelect}
          options={opts}
        />
      </div>
    </>
  )
}

const formatAddress = (a) => {
  if (!a) {
    return '&lt;no address&gt;'
  }
  return `${a.substring(0, 6)}...${a.substring(a.length - 5)}`
}

const formatChainName = (id) => {
  const net = Networks[id]
  return net ? net.name : '&lt;no network&gt;'
}

const WalletAndChain = ({ wallet, chainId }) => {
  const address = wallet ? wallet.address : undefined
  return (
    <div>
      <div>
        <b>
          NOTE: Using Wallet: {formatAddress(address)} on chain:{' '}
          {formatChainName(chainId)}
        </b>
      </div>
      <div>
        (If this is not correct, please select that account in your wallet and
        change to your desired account and approve connection to Tripsha)
      </div>
      <div>&nbsp;</div>
    </div>
  )
}

const InsufficientBalance = ({}) => {
  return (
    <span>
      You don't have sufficient funds for the token selected. Please pick a
      different token and try again.
    </span>
  )
}

const SpendIncrease = ({}) => {
  return (
    <span>
      Plase increase your spend allowance to cover Tripsha events plus any
      existing spend allowance you've applied to Uniswap's Permit2 spend
      allowance manager.
    </span>
  )
}

const SignPayment = ({}) => {
  return (
    <span>
      Please sign a spend approval for Tripsha to charge your crypto account
      once you've been approved for the event.
    </span>
  )
}

const Finished = ({}) => {
  return (
    <span>
      Thank you! Your signature will be stored and used after you are approved
      for this event!
    </span>
  )
}
